import { render, staticRenderFns } from "./ApplicationChat.vue?vue&type=template&id=5a5af191&lang=pug"
import script from "./ApplicationChat.vue?vue&type=script&lang=js"
export * from "./ApplicationChat.vue?vue&type=script&lang=js"
import style0 from "./ApplicationChat.vue?vue&type=style&index=0&id=5a5af191&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports